import React, { useState } from 'react';
import 'twin.macro';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { useParams } from 'react-router-dom';
import { useHideTitle } from 'containers/Programmations/atoms/progAtoms';
import { shortenUUID } from '@teetsh/app/src/utils/shortenUUID';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { useFormState } from 'react-final-form';
import { PrintConfig } from './types';
import { buildProgPDFParams } from './Sidebar/buildProgPDFParams';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';
import { ProgrammationPDFSettings } from '@teetsh/app/src/types/programmations';

interface Props {
  printConfig: PrintConfig;
  hiddenPeriodes: string[];
  hiddenDomaines: string[];
}

export function Body(props: Props) {
  const { printConfig } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  const { values: settings } = useFormState<ProgrammationPDFSettings>();
  const hideTitle = useHideTitle();
  const { programmationId } = useParams<{
    programmationId: string;
  }>();

  const hiddenPeriodes = props.hiddenPeriodes.map(shortenUUID).join(',');
  const hiddenDomaines = props.hiddenDomaines.map(shortenUUID).join(',');
  const matiereIds = printConfig.matiereIds.map(shortenUUID).join(',');

  const url = new URL(
    `/print/annee-scolaire/${schoolyear.id}/ecole/${school.id}/programmations/${programmationId}`,
    window.location.origin,
  );
  url.search = buildProgPDFParams({
    hiddenPeriodes,
    hiddenDomaines,
    printConfig,
    matiereIds,
    hideTitle,
    settings,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildProgPDFParams({
      hiddenPeriodes,
      hiddenDomaines,
      printConfig,
      matiereIds,
      hideTitle,
      settings,
    }),
  });

  // On utilise une iframe ici pour coller au plus près avec ce qui va être print
  // Mais la vrai raison c'est que c'est le seul moyen que j'ai trouvé pour
  // que la font size (en gros on change la dimension d'un rem) soit bien prise en compte
  // seulement au niveau de la preview du print
  return (
    <IframePreviewPDF landscape iframeUrl={urlAsString} iframeRef={iframeRef} />
  );
}
